import { fetchPersea } from "@/config/axios/config-axios";

export const getCollections = async (params = {}) => {
    return await fetchPersea('/collection', 'GET', { cache: false, ...params });
};

export const getCollection = async (id: string) => {
    return await fetchPersea('/collection', 'GET', { 
        cache: false,
        collection_key: id,
        limit: 5,
        page: 0
    });
};